import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { faPencil, faBuilding } from '@fortawesome/pro-light-svg-icons';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CompanyGroupDetailsComponent } from '../company-group-details/company-group-details.component';

@Component({
  selector: 'app-company-group',
  templateUrl: './company-group.component.html',
  styleUrls: ['./company-group.component.scss']
})
export class CompanyGroupComponent {

companyGroupId?: number;
loaded: boolean = false;

companyGroupDetails: any;

faPencil = faPencil;
faBuilding = faBuilding;

activeTab: string = 'users';

 constructor(
    activatedRoute: ActivatedRoute,
    private userService: UserService,
    public authService: AuthService,
    public modalService: ModalService) {

    activatedRoute.params.subscribe(params => {
        this.companyGroupId = +params['id'];
        this.loadCompanyGroup();
      });

  }

  loadCompanyGroup(){
      if(this.companyGroupId !== undefined && this.companyGroupId !== null){
        this.userService.companyGroupsDetails(this.companyGroupId).subscribe(result => {
          this.companyGroupDetails = result;
          this.loaded = true;
        });
      }
  }

  editCompanyGroup(){
    const modalRef = this.modalService.openWithOptions(CompanyGroupDetailsComponent, {size: 'lg'});    
        modalRef.componentInstance.companyGroupId = this.companyGroupId
    
        modalRef.result.then(
          (result) => {
            if(result)
            {
              this.loadCompanyGroup();
            }
          }
        ,
          () => {} // dismissed - do nothing
        );
  }

}
